import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation();
  
  // 1. Use the Context Logic (Login function + User State)
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  // 2. Smart Redirect: Watch for successful login & user data
  useEffect(() => {
    if (isAuthenticated && user) {
      console.log("Redirecting user based on role:", user.role);
      
      if (user.role === 'admin') {
        navigate('/admin/providers'); // Ensure this route exists in App.js
      } else if (user.role === 'provider') {
        navigate('/provider/dashboard'); // Ensure this route exists in App.js
      } else {
        navigate('/user/dashboard');
      }
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 3. Just call login(). The Context handles the API & Token.
      await login(email, password);
    } catch (err) {
      // The Context throws the error so we can alert the user here
      console.error(err);
      alert(t('reset-password.alerts.invalid-credentials'));
    }
  };

  return (
    <div className="min-h-full flex flex-col justify-center px-6 py-12 lg:px-8 bg-white">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">  
        {t('nav.login')}
        </h2>
        <p className="mt-2 text-sm text-gray-500"> {t('profile.welcome.access-tools')} </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium leading-6 text-gray-900"> {t('profile.email')} </label>
            <input 
              type="email" 
              required
              className="input-brand"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
             <label className="block text-sm font-medium leading-6 text-gray-900"> {t('profile.password')} </label>
             <input 
              type="password" 
              required
              className="input-brand"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <div className="flex justify-end mt-2">
                <Link 
                    to="/forgot-password" 
                    className="text-sm text-brand-primary hover:text-brand-primary-hover font-semibold"
                >
                    {t('reset-password.forgot-password')}
                </Link>
            </div>
          </div>

          <button type="submit" className="flex w-full justify-center rounded-md bg-brand-primary px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-brand-primary-hover">
            {t('nav.login')}
          </button>
        </form>

        <p className="mt-10 text-center text-sm text-gray-500">
         {t('profile.not-a-member')}{' '}
        <Link to="/register" className="font-semibold leading-6 text-brand-primary hover:text-brand-primary-hover">
            {t('nav.register')}
        </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
